var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.visible ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "500"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Visualizar Evento do Calendário ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    staticClass: "mb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Evento do Calendário",
      "outlined": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.content.nome,
      callback: function ($$v) {
        _vm.$set(_vm.content, "nome", $$v);
      },
      expression: "content.nome"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', {
    staticClass: "text-body-1 mr-2 grey--text text--darken-1"
  }, [_vm._v("Cor")])]), _c('sca-color-picker', {
    attrs: {
      "disabled": "",
      "cols": 2
    },
    model: {
      value: _vm.content.corHexadecimal,
      callback: function ($$v) {
        _vm.$set(_vm.content, "corHexadecimal", $$v);
      },
      expression: "content.corHexadecimal"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex align-center mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('span', {
    staticClass: "text-body-1 mr-2 grey--text text--darken-1"
  }, [_vm._v("Dia Letivo")])]), _c('v-switch', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.content.diaLetivo,
      callback: function ($$v) {
        _vm.$set(_vm.content, "diaLetivo", $$v);
      },
      expression: "content.diaLetivo"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")]), _vm._v(" Fechar ")], 1)], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }